import { __rest } from "tslib";
import * as React from 'react';
import cn from 'classnames';
import { CardExtraView, CardExtraViewAggregator, CardExtraIcon } from '@shared/ui';
import { useTheme } from '../../../../theme';
import CommonContent from '../CommonContent';
const ServiceCard = (_a) => {
    var { mode = 'default', type, className, title, description, getServiceName } = _a, commonContentProps = __rest(_a, ["mode", "type", "className", "title", "description", "getServiceName"]);
    const theme = useTheme('RefundSummary').CommonContent;
    const content = React.createElement(CommonContent, Object.assign({}, commonContentProps, { getServiceName: getServiceName }));
    const cardProps = {
        type,
        title,
        description,
        classes: {
            root: cn(theme.serviceCard, className),
            header: theme.serviceCard_header,
            header__icon: theme.serviceCard_header__icon,
            content: theme.serviceCard_content,
            footer: theme.serviceCard_footer
        },
        icon: React.createElement(CardExtraIcon, { type: type }),
        content
    };
    if (mode === 'aggregator') {
        return React.createElement(CardExtraViewAggregator, Object.assign({}, cardProps));
    }
    return React.createElement(CardExtraView, Object.assign({}, cardProps));
};
export default ServiceCard;
